import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = logged out, obj = logged in

  useEffect(() => {
    if (typeof window !== "undefined" && !window.location.pathname.startsWith("/admin")) {
      setUser(false);
      return;
    }
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data);
    return data;
  };

  const loginPin = async (pin) => {
    const { data } = await api.post("/auth/pin", { pin });
    setUser(data);
    return data;
  };

  const staffLogin = async (username, code) => {
    const { data } = await api.post("/crm/staff/login", { username, code });
    setUser(data);
    return data;
  };

  const changeCode = async (new_code) => {
    const { data } = await api.post("/crm/staff/change-code", { new_code });
    return data;
  };

  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, login, loginPin, staffLogin, changeCode, logout }}>
      {children}
    </AuthContext.Provider>
  );
}
